import { IconCheckCircleFilled } from '@iwoca/icons';
import { FormattedMessage } from 'react-intl';

import { TFundingRequirementsSteps } from '../orderFundingRequirements';
import StepItem from '../stepItem/StepItem';

export const WaitForOtherGuarantorsAction = ({
    step
}: {
    step: TFundingRequirementsSteps[number] & { pg_name?: string };
}) => {
    return (
        <StepItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.wait_for_other_guarantors_title"
                    defaultMessage="{pgName}’s checks"
                    values={{ pgName: step.pg_name }}
                />
            }
            caption={
                <FormattedMessage
                    id="_.funding_requirements.wait_for_other_guarantors_caption"
                    defaultMessage="We need {pgName} to complete their steps."
                    values={{ pgName: step.pg_name }}
                />
            }
            action={
                step.status === 'COMPLETED' ? (
                    <div className="px-l py-s min-sm:py-0">
                        <IconCheckCircleFilled
                            height="24"
                            width="24"
                            fill="rgba(0, 77, 51, 1)"
                            xlinkTitle="checked"
                        />
                    </div>
                ) : null
            }
        />
    );
};
